module.exports = __webpack_public_path__ + "static/media/wallet-stmt-icon.fbabb925.svg";